import { useQuery } from "@tanstack/react-query";
import { getListUser } from "../services/listUserService";

interface User {
  id: string;
  username: string;
  email: string;
  status: string;
  enabled: boolean;
  createdDate: string;
  lastModifiedDate: string;
  userGroups: string[];
}

export const useListUser = () => {
  return useQuery<User[]>({
    queryKey: ["listUser"],
    queryFn: async () => {
      const response = await getListUser();
      // Map the API response to match the User interface
      return response.map((user: any) => ({
        id: user.username, // Use username as a unique ID
        username: user.username,
        email: user.email,
        status: user.status,
        enabled: user.enabled,
        createdDate: user.created_date,
        lastModifiedDate: user.last_modified_date,
        userGroups: user.groups || [], // Ensure userGroups is always an array
      }));
    },
    staleTime: 1000 * 60 * 5, // Cache data for 5 minutes
    retry: 2, // Retry failed requests up to 2 times
  });
};